import {
  COMMO_THEME_CONTRACT,
  resolveCommoThemeIsDark,
} from './theme-contract.generated';

export { COMMO_THEME_CONTRACT, resolveCommoThemeIsDark };

/** Appearance preference stored in localStorage. Default when unset: system. */
export type CommoThemePreference = 'system' | 'light' | 'dark';

/** E2E / FOUC boot（theme-boot.js）と同じキー。正は theme-contract.json。 */
export const COMMO_THEME_STORAGE_KEY = COMMO_THEME_CONTRACT.storageKey;

export const COMMO_THEME_PREFERENCES = [
  'system',
  'light',
  'dark',
] as const satisfies readonly CommoThemePreference[];

export function isCommoThemePreference(
  value: unknown,
): value is CommoThemePreference {
  return value === 'system' || value === 'light' || value === 'dark';
}

/** html に付ける Ionic 公式の dark パレットクラス。 */
export const COMMO_ION_PALETTE_DARK_CLASS = COMMO_THEME_CONTRACT.darkClass;

/** html に付ける Ionic mode（背景トークンは `.ion-palette-dark.md`）。 */
export const COMMO_ION_MODE_CLASS = COMMO_THEME_CONTRACT.modeClass;
